export const getStyled = (theme) => ({
  formControl: {
    marginBottom: theme.spacing(2),
    minWidth: 300,
  },
  inputFile: {
    display: 'none',
  },
  buttonFile: {
    marginBottom: theme.spacing(2),
  },
  dialogTitleWrapper: {
    position: 'relative',
  },
  primaryBar: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '100%',
    backgroundColor: theme.custom.colors.defaultBackground,
    zIndex: 1,
  },
  dialogTitle: {
    position: 'relative',
    zIndex: 2,
    color: theme.custom.colors.text,
  },
});
